import React from "react";
import "./error.scss";

const Error = () => {
  // Only claim the visitor is offline when the browser actually says so.
  // `!navigator.onLine` was wrong on the server in two different ways: under Node 16
  // `navigator` did not exist at all, so rendering this threw and took the SSR pass
  // with it; under Node 24 there is a global `navigator` but no `onLine` on it, so the
  // negation is always true and every server-rendered error told the visitor they had
  // lost their connection. Ported from HQ-8880.
  const isOffline =
    typeof navigator !== "undefined" && navigator.onLine === false;

  return (
    <div className="Error">
      <div className="Error-inner">
        {isOffline ? "It appears you are offline." : "Error"}
      </div>
    </div>
  );
};

export default Error;
